import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
export const ToggleBodyScroll = t0 => {
  const $ = _c(3);
  const {
    open
  } = t0;
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      if (open) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
      return _temp;
    };
    t2 = [open];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
};
function _temp() {
  document.body.classList.remove("overflow-hidden");
}